
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon58Chat3X = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 174,
  height: 174,
  viewBox: "0 0 58 58",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.759 21.708a3.434 3.434 0 1 0-3.434-3.423 3.423 3.423 0 0 0 3.434 3.423z",
  fill: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.167 16.037C56.167 11.205 52.81 7 48.215 7v2.237c2.997 0 5.692 2.897 5.692 6.8h2.26zm0 16.934V16.037H53.93v16.934h2.237zm-7.952 9.037c4.54 0 7.952-4.206 7.952-9.037H53.93c0 3.903-2.707 6.777-5.693 6.777l-.022 2.26zm-29.863 0h29.863V39.77H18.352v2.237zm-.358 2.125 1.364-2.752-2.024-1.006-1.365 2.74 2.025 1.018zm-2.405 4.831 2.405-4.831-2.025-1.018-2.415 4.843 2.035 1.006zm-4.474-4.831 2.405 4.831 2.036-1.006-2.371-4.843-2.07 1.018zM9.83 41.38l1.32 2.752 2.036-1.018-1.376-2.74-1.98 1.006zm.168.627h.839V39.77h-.884l.045 2.237zM2 32.97c0 4.831 3.411 9.037 7.952 9.037V39.77c-2.986-.023-5.715-2.897-5.715-6.8H2zm0-16.934V32.97h2.237V16.037H2zM9.952 7C5.412 7 2 11.205 2 16.037h2.237c0-3.903 2.729-6.8 5.715-6.8V7zm38.263 0H9.952v2.237h38.263V7zM18.352 40.878V39.76h-.694l-.313.626 1.007.492zm-1.365 2.74-1.018-.503 1.018.503zm-2.416 4.843-1.017.503L14.57 51l1.018-2.036-1.018-.503zm-2.415-4.843 1.017-.503-1.017.503zm-1.365-2.74 1.018-.503-.313-.627h-.705v1.13z",
  fill: "#000"
}))));

      const __svgRaw = "<svg width=\"174\" height=\"174\" viewBox=\"0 0 58 58\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g fill-rule=\"nonzero\" fill=\"none\">\r\n        <path d=\"M44.759 21.708a3.434 3.434 0 1 0-3.434-3.423 3.423 3.423 0 0 0 3.434 3.423z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n        <path d=\"M56.167 16.037C56.167 11.205 52.81 7 48.215 7v2.237c2.997 0 5.692 2.897 5.692 6.8h2.26zm0 16.934V16.037H53.93v16.934h2.237zm-7.952 9.037c4.54 0 7.952-4.206 7.952-9.037H53.93c0 3.903-2.707 6.777-5.693 6.777l-.022 2.26zm-29.863 0h29.863V39.77H18.352v2.237zm-.358 2.125 1.364-2.752-2.024-1.006-1.365 2.74 2.025 1.018zm-2.405 4.831 2.405-4.831-2.025-1.018-2.415 4.843 2.035 1.006zm-4.474-4.831 2.405 4.831 2.036-1.006-2.371-4.843-2.07 1.018zM9.83 41.38l1.32 2.752 2.036-1.018-1.376-2.74-1.98 1.006zm.168.627h.839V39.77h-.884l.045 2.237zM2 32.97c0 4.831 3.411 9.037 7.952 9.037V39.77c-2.986-.023-5.715-2.897-5.715-6.8H2zm0-16.934v16.934h2.237V16.037H2zM9.952 7C5.412 7 2 11.205 2 16.037h2.237c0-3.903 2.729-6.8 5.715-6.8V7zm38.263 0H9.952v2.237h38.263V7zM18.352 40.878V39.76h-.694l-.313.626 1.007.492zm-1.365 2.74-1.018-.503 1.018.503zm-2.416 4.843-1.017.503L14.57 51l1.018-2.036-1.018-.503zm-2.415-4.843 1.017-.503-1.017.503zm-1.365-2.74 1.018-.503-.313-.627h-.705v1.13z\" fill=\"#000000\"/>\r\n    </g>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-58-chat@3x.65599dabcb80006e9c1f58c0297217cb.svg"),
        {
          React: SvgIcon58Chat3X,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      